export class LogaDay {

  public static fromJson(json: Object): LogaDay {
    const o: LogaDay = new LogaDay();

    o.id = json['id'];
    o.year = json['year'];
    o.month = json['month'];
    o.dayOfMonth = json['dayOfMonth'];
    o.dayOfWeek = json['dayOfWeek'];
    o.publicHoliday = json['publicHoliday'];

    return o;
  }

  public id : number;
  public year : number;
  public month : number;
  public dayOfMonth  : number;
  public dayOfWeek : number;
  public publicHoliday : boolean;


}



// WEBPACK FOOTER //
// ./src/model/LogaDay.ts